
// import { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "./App.css";
// import HeaderTabComponent from "./components/HeaderTabComponent";
// import FooterTabComponent from "./components/FooterTabComponent";
// import Dashboard from "./components/Dashboard";
// import MainContent from "./components/MainContent";
// import AuthModal from "./components/AuthModal";
// import AIandDigital from "./components/AIandDigital";
// import Optioncard from "./components/Optioncard";
// import Admin from "./components/Admin";
// import AdminForm from "./components/AdminForm";

// function App() {
//   const [user, setUser] = useState(null);
//   const [showAuthModal, setShowAuthModal] = useState(false);
//   const [authMode, setAuthMode] = useState("login");
//   const [authType, setAuthType] = useState("user");
//   const [activeTab, setActiveTab] = useState("india-energy-week");
//   const [showDashboard, setShowDashboard] = useState(false);
//   const [showMainContent, setShowMainContent] = useState(false);

//   useEffect(() => {
//     const savedUser = localStorage.getItem("fipi_user");
//     if (savedUser) {
//       setUser(JSON.parse(savedUser));
//     }
//   }, []);

//   const handleLogin = (userData) => {
//     setUser(userData);
//     localStorage.setItem("fipi_user", JSON.stringify(userData));
//     setShowAuthModal(false);
//   };

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem("fipi_user");
//     setShowDashboard(false);
//   };

//   const handleShowAuth = (mode = "login", type = "user") => {
//     setAuthMode(mode);
//     setAuthType(type);
//     setShowAuthModal(true);
//   };

//   const handleShowDashboard = () => {
//     setShowDashboard(true);
//   };

//   return (
//     <Router>
//       <div className="App">
//         <HeaderTabComponent />
//         <Routes>
//           <Route path="/AIandDigital" element={<AIandDigital />} />
//           <Route path="/Optioncard" element={<Optioncard />} />
//           <Route path="/fipidigilibrary/Admin" element={<Admin />} />
//           <Route path="/fipidigilibrary/AdminForm" element={<AdminForm/>} />

//           <Route
//             path="/fipidigilibrary/"
//             element={
//               <>
//                 {!showMainContent ? (
//                   <Dashboard onIEWClick={() => setShowMainContent(true)} />
//                 ) : (
//                   <MainContent
//                     user={user}
//                     activeTab={activeTab}
//                     setActiveTab={setActiveTab}
//                     onShowAuth={handleShowAuth}
//                     onShowDashboard={handleShowDashboard}
//                     onLogout={handleLogout}
//                   />
//                 )}
//               </>
//             }
//           />
//         </Routes>

//         {showAuthModal && (
//           <AuthModal
//             mode={authMode}
//             type={authType}
//             onClose={() => setShowAuthModal(false)}
//             onLogin={handleLogin}
//             onSwitchMode={(newMode) => setAuthMode(newMode)}
//           />
//         )}
//       </div>
//       <FooterTabComponent />
//     </Router>
//   );
// }

// export default App;



import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import HeaderTabComponent from "./components/HeaderTabComponent";
import FooterTabComponent from "./components/FooterTabComponent";
import Dashboard from "./components/Dashboard";
import MainContent from "./components/MainContent";
import AIandDigital from "./components/AIandDigital";
import Optioncard from "./components/Optioncard";
import Admin from "./components/Admin";
import AdminForm from "./components/AdminForm";
import FipiPublication from "./components/FipiPublication";
import Notification from "./components/Notification";
import Recommendation from "./components/Recommendation";
import ImportantLinks from "./components/ImportantLinks";
import AdminImportantLinks from "./components/AdminImportantLinks";
import AdminGazattenotification from "./components/AdminGazattenotification";
import Adminyoutubelink from "./components/Adminyoutubelink";
import AdminTracking from "./components/AdminTracking";
import Reports from "./components/Reports";
import ErrorBoundary from "./components/ErrorBoundary";

import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";

/* ================= ROUTES COMPONENT ================= */

function AppRoutes() {
  const { authUser, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("india-energy-week");

  return (
    <>
      <HeaderTabComponent />

      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/AIandDigital" element={<AIandDigital />} />
        <Route path="/Optioncard" element={<Optioncard />} />

        {/* PROTECTED LIBRARY */}
        {/* USER LIBRARY */}
        <Route
          path="/library"
          element={
            <ProtectedRoute allow="user">
              <MainContent
                user={authUser}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onLogout={logout}
              />
            </ProtectedRoute>
          }
        />

        {/* ADMIN PANEL */}
        <Route
          path="/Admin"
          element={
            <ProtectedRoute allow="admin">
              <Admin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AdminForm"
          element={
            <ProtectedRoute allow="admin">
              <AdminForm />
            </ProtectedRoute>
          }
        />

        {/* OTHER */}
        <Route path="/fipi-publication" element={<FipiPublication />} />
        <Route path="/Notification" element={<Notification />} />
        <Route path="/fipi-recommendation" element={<Recommendation />} />
        <Route path="/important-links" element={<ImportantLinks />} />
        <Route path="/admin-important-links" element={<AdminImportantLinks />} />
        <Route path="/AdminGazattenotification" element={<AdminGazattenotification />} />
        <Route path="/Adminyoutubelink" element={<Adminyoutubelink />} />
        <Route path="/AdminTracking" element={<AdminTracking />} />
        <Route path="/Reports" element={<Reports />} />
        <Route path="/video/:category" element={<AIandDigital />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <FooterTabComponent />
    </>
  );
}

/* ================= MAIN APP ================= */

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <Router >
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  </ErrorBoundary>
  );
}

export default App;
